import {
  CartContextChangedError,
  CartMutationGuard,
  enqueueCartMutation,
} from '~/modules/checkout/composables/useCart/cartCoordinator';
import { useCartStore } from '~/modules/checkout/stores/cart';

/** Share the existing cart queue with address/delivery writes, never payment execution. */
export const withCheckoutCartWrite = <T>(
  app: any,
  cartId: string,
  operation: (guard: CartMutationGuard) => Promise<T>,
): Promise<T> => {
  const store = useCartStore();
  const { state } = app.$vsf.$magento.config;
  const identity = () => ({
    cartId: (state.getCartId ? state.getCartId() : cartId) || '',
    customer: state.getCustomerToken?.() || '',
    store: state.getStore?.() || '',
    locale: state.getLocale?.() || '',
    currency: state.getCurrency?.() || '',
  });
  if (!cartId || identity().cartId !== cartId) return Promise.reject(new CartContextChangedError());
  return enqueueCartMutation(store, identity, operation);
};
